import React, { useState } from "react";
import { Link } from "react-router-dom";
import WebsiteLayout from "@/components/common/Layouts/WebsiteLayout";
import { INSTITUTION_INFO } from '@/config/constants';

const FAQ = () => {
  const [expandedId, setExpandedId] = useState(null);

  const faqItems = [
    {
      id: 1,
      question: "कोर्स की अवधि कितनी है?",
      answer:
        "सभी कोर्स 1 महीने की अवधि के हैं। इस दौरान आप हर दिन प्रैक्टिकल और थिओरी क्लासेस में शामिल होंगे।",
    },
    {
      id: 2,
      question: "कोर्स के लिए न्यूनतम योग्यता क्या है?",
      answer:
        "आपकी उम्र कम से कम 18 साल होनी चाहिए और आप 8वीं पास हों। आपके पास वैध सरकारी आईडी होना जरूरी है।",
    },
    {
      id: 3,
      question: "क्या रूम और भोजन दिया जाता है?",
      answer:
        "हां, कोर्स शुल्क में रूम और भोजन शामिल है। अगर आप बिना रूम और भोजन के कोर्स करना चाहते हैं तो कम शुल्क है।",
    },
    {
      id: 4,
      question: "कार प्रशिक्षण कब दिया जाता है?",
      answer:
        "कार प्रशिक्षण बिल्कुल मुफ्त है और यह कोर्स के समय दिया जाता है। यह आपकी मशीन ऑपरेशन स्किल सुधारने में मदद करता है।",
    },
    {
      id: 5,
      question: "JCB और एक्सकेवेटर में क्या फर्क है?",
      answer:
        "JCB (Backhoe Loader) एक बहु-उद्देश्यीय मशीन है जो खुदाई, लोडिंग और अन्य कार्यों के लिए उपयोगी है। एक्सकेवेटर मुख्य रूप से गहरी खुदाई के लिए बनी है। दोनों में अलग-अलग ऑपरेशन तकनीकें हैं।",
    },
    {
      id: 6,
      question: "क्या प्रमाण पत्र मिलेगा?",
      answer:
        "हां, कोर्स पूरा करने के बाद आपको प्रमाण पत्र दिया जाएगा। इसके लिए आपको कम से कम 80% कक्षाओं में उपस्थित होना चाहिए और सभी प्रैक्टिकल परीक्षाओं में शामिल होना चाहिए।",
    },
    {
      id: 7,
      question: "यह प्रमाण पत्र कहाँ मान्य है?",
      answer:
        "हमारा प्रमाण पत्र भारत में निर्माण कार्य, खदान, और अन्य भारी मशीनरी परियोजनाओं में मान्य है। आप इसे अपना रिज्यूमे में जोड़ सकते हैं।",
    },
    {
      id: 8,
      question: "क्या जॉब प्लेसमेंट दी जाती है?",
      answer:
        "हम अपने छात्रों को जॉब प्लेसमेंट में मदद देते हैं। हमारा काम करते कई कंपनियों के साथ संबंध है। आपकी योग्यता और अनुभव के आधार पर हम आपको नौकरी के अवसर प्रदान करते हैं।",
    },
    {
      id: 9,
      question: "अगर मैं कोर्स के बीच में छोड़ देता हूं तो क्या होगा?",
      answer:
        "अगर आप कोर्स शुरू होने से 7 दिन पहले रद्दीकरण के लिए कहते हैं तो 50% रिफंड मिलेगा। कोर्स शुरू होने के बाद रद्दीकरण पर कोई रिफंड नहीं दिया जाएगा।",
    },
    {
      id: 10,
      question: "आवेदन की प्रक्रिया क्या है?",
      answer:
        "हमारी वेबसाइट पर रजिस्ट्रेशन फॉर्म भरें। अपनी व्यक्तिगत जानकारी, शिक्षा योग्यता और कौन सा कोर्स करना चाहते हो ये बताएं। फिर फी जमा करें और अपना शुरुआत की तारीख चुनें।",
    },
    {
      id: 11,
      question: "क्या महिलाएं भी कोर्स कर सकती हैं?",
      answer:
        "हां, बिल्कुल! महिलाएं भी सभी कोर्स के लिए योग्य हैं। हम समान अवसर प्रदान करते हैं।",
    },
    {
      id: 12,
      question: "अगर मेरे पास कोर्स में कोई प्रश्न हो तो क्या हो?",
      answer:
        "हमारे प्रशिक्षक हमेशा आपके सवालों का जवाब देने के लिए तैयार हैं। क्लास के दौरान और क्लास के बाद दोनों समय आप उनसे पूछ सकते हैं।",
    },
    {
      id: 13,
      question: "लोडर और डोजर में अंतर क्या है?",
      answer:
        "लोडर एक बहु-उद्देश्यीय मशीन है जो सामग्री को उठाकर ले जाने के लिए उपयोग होती है। डोजर (बुलडोजर) मुख्य रूप से जमीन को समतल करने, धकेलने और खोदने के लिए उपयोग होता है।",
    },
    {
      id: 14,
      question: "ग्रेडर का क्या उपयोग है?",
      answer:
        "ग्रेडर एक मशीन है जो सड़क के निर्माण में सामग्री को समतल, मिश्रित और समझाने के लिए उपयोग होती है। यह एक विशेष मशीन है।",
    },
    {
      id: 15,
      question: "क्या मेरे पास कोई अनुभव होना चाहिए?",
      answer:
        "नहीं, यह कोर्स शुरुआती लोगों के लिए भी है। हम आपको सुरक्षा और सभी जरूरी कौशल से शुरू करते हुए सिखाते हैं।",
    },
  ];

  const toggleExpanded = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <WebsiteLayout className="pt-16 lg:pt-20">
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="h1 text-center mb-4">अक्सर पूछे जाने वाले सवाल</h1>
          <p className="text-center text-gray-600 dark:text-gray-400 mb-12">
            हमारे कोर्स और प्रशिक्षण के बारे में सामान्य सवालों के जवाब
          </p>

          <div className="space-y-4">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden"
              >
                <button
                  onClick={() => toggleExpanded(item.id)}
                  className="w-full p-6 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200 flex justify-between items-center"
                >
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {item.question}
                  </span>
                  <svg
                    className={`w-6 h-6 text-gray-600 dark:text-gray-400 transition-transform duration-200 ${
                      expandedId === item.id ? "transform rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 14l-7 7m0 0l-7-7m7 7V3"
                    />
                  </svg>
                </button>

                {expandedId === item.id && (
                  <div className="px-6 pb-6 pt-2 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Additional Help Section */}
          <div className="mt-12 p-8 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
            <h2 className="h3 mb-3">अधिक मदद चाहिए?</h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              अगर आपके सवालों का जवाब यहां नहीं मिला, तो कृपया हमसे सीधे संपर्क
              करें। हमारी टीम आपकी मदद के लिए हमेशा तैयार है।
            </p>
            <div className="space-y-2 text-sm">
              <p className="text-gray-700 dark:text-gray-300">
                📞 <strong>फोन:</strong> {INSTITUTION_INFO.contact.mobile.primary}, {INSTITUTION_INFO.contact.mobile.secondary}
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                📧 <strong>ईमेल:</strong> {INSTITUTION_INFO.contact.email}
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                📍 <strong>पता:</strong> {INSTITUTION_INFO.contact.address}
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700 text-center">
            <Link
              to="/"
              className="text-yellow-600 dark:text-yellow-400 hover:text-yellow-700 dark:hover:text-yellow-300 font-medium"
            >
              ← वापस होम पेज
            </Link>
          </div>
        </div>
      </div>
    </WebsiteLayout>
  );
};

export default FAQ;
